import { getInitialState, getPath } from "../../utils";

const initialState = {
  campaignList: [],
  prevPage: -1,
  nextPage: -1,
  activeCampaign: { serviceId: [] },
  activeFilters: { serviceId: [] },
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CAMPAIGN_LIST":
      return setCampaignList(state, action);
    case "SET_ACTIVE_CAMPAIGN":
      return setActiveCampaign(state, action);
    case "SET_ACTIVE_FILTERS_CAMPAIGN":
      return setActiveFilters(state, action);
    case "SET_CURRENT_PAGE_CAMPAIGN":
      return setCurrentPageFeature(state, action);
    case "RESET_STATE_CAMPAIGN":
      return resetState(state, action);
    default:
      return state;
  }
}

const setCurrentPageFeature = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setCampaignList = (state, action) => {
  return {
    ...state,
    campaignList: getPath(action.payload, "campaigns", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveCampaign = (state, action) => {
  return {
    ...state,
    activeCampaign: action.payload,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
